import SignupWithEmail from "./SignupWithEmail";

export default SignupWithEmail;